import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Heading from "src/components/Heading";
import Button from "src/components/Button";
import GreenArrow from "/static/green-arrow.svg";
import { Link } from "gatsby";

const Hero = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="bg-white">
        <div className="mx-auto my-16 max-w-7xl px-8">
          <div className="font-display block text-9xl font-semibold uppercase tracking-[2px]">
            Hero
          </div>
          <Heading size="h1">Heading 1</Heading>
          <Heading size="h2">Heading 2</Heading>
          <Heading size="h3">Heading 3</Heading>
          <Heading size="h4">Heading 4</Heading>
          <Heading size="h5">Heading 5</Heading>
          <Heading size="h6">Heading 6</Heading>
          <Heading size="h7" className="block">
            Heading 7
          </Heading>
          <Heading size="h1" className="text-brightgreen">
            Bright green
          </Heading>
          <Heading size="h1" className="text-lightblue">
            Light blue
          </Heading>
          <Heading size="h1" className="text-darkblue">
            Dark blue
          </Heading>
          <Heading size="h1" className="text-teal">
            Teal
          </Heading>
          <Button
            to={`/${blok.button_target.cached_url}`}
            before={blok.button_text}
            className={`bg-brightgreen hover:bg-brightgreenhover mr-3 before:content-[attr(before)]`}
          >
            {blok.button_text}
          </Button>
          <Button
            to={`/${blok.button_target.cached_url}`}
            before={blok.button_text}
            className="bg-darkblue hover:bg-darkbluehover mr-3 before:content-[attr(before)]"
          >
            {blok.button_text}
          </Button>
          <Button
            to={`/${blok.button_target.cached_url}`}
            before={blok.button_text}
            className="hover:bg-lightblue text-darkblue bg-white before:content-[attr(before)]"
          >
            {blok.button_text}
          </Button>
          <div className="prose mt-12">
            <RichText>{blok.main_content}</RichText>
          </div>
          <Link to="/" className="text-brightgreen group flex flex-row">
            Read more{" "}
            <img
              className="pl-1 transition-all duration-300 ease-in-out will-change-transform group-hover:pl-2"
              src={GreenArrow}
            />
          </Link>
        </div>
      </div>
    </SbEditable>
  );
};

export default Hero;
